import RoleBadge from "./RoleBadge";

const UserRow = ({ user, onEdit, onDelete }) => {

    return (
        <tr className="border-t hover:bg-gray-50">

            <td className="p-4">
                {user.firstName} {user.lastName}
            </td>

            <td className="p-4">
                {user.phone}
            </td>

            <td className="p-4">
                <RoleBadge role={user.role} />
            </td>

            <td className="p-4 flex gap-2">

                <button
                    onClick={() => onEdit(user)}
                    className="px-3 py-1 rounded-lg bg-blue-50 text-blue-600"
                >
                    ویرایش
                </button>

                <button
                    onClick={() => onDelete(user)}
                    className="px-3 py-1 rounded-lg bg-red-50 text-red-600"
                >
                    حذف
                </button>

            </td>

        </tr>
    );
};

export default UserRow;
